module.exports = __webpack_public_path__ + "static/media/card-blog10.62ac9c0e.jpg";